import React, { useEffect, useMemo } from 'react';

function formatDateForInput(date) {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
}

function resolveOffsetDays(defaultOffsetDays) {
	if (defaultOffsetDays === null || defaultOffsetDays === undefined || defaultOffsetDays === '') {
		return null;
	}

	if (typeof defaultOffsetDays === 'number' && Number.isInteger(defaultOffsetDays)) {
		return defaultOffsetDays;
	}

	if (typeof defaultOffsetDays === 'string') {
		const trimmed = defaultOffsetDays.trim();
		if (!trimmed) {
			return null;
		}
		if (!/^[-+]?\d+$/.test(trimmed)) {
			return null;
		}
		return Number.parseInt(trimmed, 10);
	}

	return null;
}

function DateFilterWidget({ value = '', onChange, defaultOffsetDays = null }) {
	const selectedValue = useMemo(() => {
		if (value === undefined || value === null) {
			return '';
		}
		return String(value);
	}, [value]);

	useEffect(() => {
		if (selectedValue) {
			return;
		}

		const offsetDays = resolveOffsetDays(defaultOffsetDays);
		if (offsetDays === null || typeof onChange !== 'function') {
			return;
		}

		const nextDate = new Date();
		nextDate.setDate(nextDate.getDate() + offsetDays);
		onChange(formatDateForInput(nextDate));
	}, [selectedValue, defaultOffsetDays, onChange]);

	return (
		<div className="flex h-full w-full items-center justify-center">
			<div className="w-full max-w-sm">
				<label className="mb-1 block text-[11px] font-medium uppercase tracking-wide text-slate-500">Date</label>
				<input
					type="date"
					value={selectedValue}
					onChange={(event) => {
						if (typeof onChange === 'function') {
							onChange(event.target.value);
						}
					}}
					className="h-9 w-full rounded-md border border-slate-300 bg-white px-3 text-xs text-slate-700 outline-none transition focus:border-slate-500 focus:ring-2 focus:ring-slate-200"
				/>
			</div>
		</div>
	);
}

export default DateFilterWidget;
